import { Fragment } from "react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@tellescope/ui";
import type { BreadcrumbItem as BreadcrumbItemData } from "./useBreadcrumbs";

interface BreadcrumbsProps {
  items: BreadcrumbItemData[];
}

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
  if (items.length === 0) return null;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {items.map((item, index) => (
          <Fragment key={item.label}>
            {index > 0 && <BreadcrumbSeparator />}
            <BreadcrumbItem onClick={item.onClick} className={item.onClick ? "cursor-pointer" : undefined}>
              <BreadcrumbPage className={item.onClick ? "hover:text-foreground transition-colors" : undefined}>
                {item.label}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
